import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=9979ccc0"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports